import { useDistribuicoes } from "./use-distribuicoes";
import { DistribuicoesView } from "./view-distribuicoes";

export function DistribuicoesScreen() {
  const vm = useDistribuicoes();

  return <DistribuicoesView {...vm} />;
}

export type * from "./types-distribuicoes";
